module.exports = __webpack_public_path__ + "media/applications/assets/images/size-info/pleated_skirt-0938d022ff90583c362f0036310e767a.png";